import { getStorage, setStorage } from '@/utils/storage'

const PLATFORM_CONFIG_KEY = 'ftx_platform_config'

// 多环境配置：邀请链接基础地址
const webUrl = process.env.VUE_APP_WEB_URL || 'https://localhost'

export const DEFAULT_PLATFORM_CONFIG = {
  depositAddress: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb0',
  minDeposit: 10,
  leverage: 100,
  goldQuickLots: [0.01, 0.1, 1, 10],
  silverQuickLots: [0.05, 1, 5, 10, 20],
  inviteBaseUrl: webUrl + '/#/home'
}

export function getPlatformConfig() {
  return getStorage(PLATFORM_CONFIG_KEY, DEFAULT_PLATFORM_CONFIG)
}

export function savePlatformConfig(config) {
  setStorage(PLATFORM_CONFIG_KEY, { ...DEFAULT_PLATFORM_CONFIG, ...config })
}

export function getLeverage() {
  return getPlatformConfig().leverage
}

export function getDepositAddress() {
  return getPlatformConfig().depositAddress
}

export function getMinDeposit() {
  return getPlatformConfig().minDeposit
}

export function getQuickLots(symbol) {
  const config = getPlatformConfig()
  return symbol === 'XAGUSD' ? config.silverQuickLots : config.goldQuickLots
}

export function calcMarginByLotsAndLeverage(lots, leverage) {
  // 1 lot = 1000 USD notional; margin = notional / leverage
  // At leverage 100: 0.01 lot = 0.10 USD, 0.50 lot = 5 USD
  return lots * 1000 / leverage
}

export function getInviteBaseUrl() {
  // 优先使用当前页面域名，避免 localStorage 缓存旧域名
  const origin = window.location.origin
  if (origin && origin !== 'https://localhost') {
    return origin + '/#/home'
  }
  // 开发环境 fallback
  return getPlatformConfig().inviteBaseUrl
}

export function getDepositNetwork() {
  return getPlatformConfig().depositNetwork || 'BEP20 (BSC)'
}

export function getWithdrawNetwork() {
  return getPlatformConfig().withdrawNetwork || 'BEP20 (BSC)'
}

export function getWithdrawFee() {
  return getPlatformConfig().withdrawFee || 1
}

export function getMinWithdraw() {
  return getPlatformConfig().minWithdraw || 10
}

export function getMinExchange() {
  return getPlatformConfig().minExchange || 10
}

export function getTradeFeeRate() {
  return getPlatformConfig().tradeFeeRate || 0.001
}

export function getRegisterEnabled() {
  return getPlatformConfig().registerEnabled !== 0
}

export function getMaintenanceMode() {
  return getPlatformConfig().maintenanceMode === 1 || getPlatformConfig().maintenanceMode === true
}

export function getTradeEnabled() {
  return getPlatformConfig().tradeEnabled !== 0
}

export function getPlatformName() {
  return getPlatformConfig().platformName || ''
}

export function getPlatformSubtitle() {
  return getPlatformConfig().platformSubtitle || ''
}

export function getLogoUrl() {
  return getPlatformConfig().logoUrl || ''
}

/**
 * 从后端 API 同步平台配置到 localStorage
 * 在 App.vue checkMaintenance() 中调用，将公共配置写入本地
 */
export function syncPlatformConfigFromApi(data) {
  if (!data) return
  const current = getPlatformConfig()
  const updates = {}
  if (data.platformName !== undefined) updates.platformName = data.platformName
  if (data.platformSubtitle !== undefined) updates.platformSubtitle = data.platformSubtitle
  if (data.logoUrl !== undefined) updates.logoUrl = data.logoUrl
  if (data.maintenanceMode !== undefined) updates.maintenanceMode = data.maintenanceMode
  if (data.registerEnabled !== undefined) updates.registerEnabled = data.registerEnabled
  if (data.tradeEnabled !== undefined) updates.tradeEnabled = data.tradeEnabled
  if (data.depositNetwork !== undefined) updates.depositNetwork = data.depositNetwork
  if (data.depositAddress !== undefined) updates.depositAddress = data.depositAddress
  if (data.withdrawNetwork !== undefined) updates.withdrawNetwork = data.withdrawNetwork
  if (data.minDeposit !== undefined) updates.minDeposit = data.minDeposit
  if (data.minWithdraw !== undefined) updates.minWithdraw = data.minWithdraw
  if (data.withdrawFee !== undefined) updates.withdrawFee = data.withdrawFee
  if (data.minExchange !== undefined) updates.minExchange = data.minExchange
  if (data.tradeFeeRate !== undefined) updates.tradeFeeRate = data.tradeFeeRate
  savePlatformConfig({ ...current, ...updates })
}

// ===== Deposit Request CRUD =====
const DEPOSIT_REQUESTS_KEY = 'ftx_deposit_requests'

export function getDepositRequests() {
  return getStorage(DEPOSIT_REQUESTS_KEY, [])
}

export function addDepositRequest(req) {
  const list = getDepositRequests()
  list.unshift({
    id: Date.now(),
    ...req,
    status: 'pending',
    createdAt: Date.now()
  })
  setStorage(DEPOSIT_REQUESTS_KEY, list)
  return list
}

export function updateDepositRequest(id, updates) {
  const list = getDepositRequests()
  const idx = list.findIndex(r => r.id === id)
  if (idx !== -1) {
    list[idx] = { ...list[idx], ...updates }
    setStorage(DEPOSIT_REQUESTS_KEY, list)
  }
  return list
}

export function formatDepositTime(ts) {
  if (!ts) return '--'
  const d = new Date(ts)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}
